import { DetailHeaderCard, Tabs } from "../../../components";
import { useTranslation } from "react-i18next";
import { Pages } from '../../../shared/enums'
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useCallback, useMemo } from "react";
import { getDriverDetail } from "../../../api/driver";
import dayjs from "dayjs";
import Button from "../../../components/common/Button";
import { DATETIME_FORMAT } from "../../../shared/constants";
import DriverOrder from "./tabs/order";
import DriverWallet from "./tabs/wallet";
import { RiEdit2Fill } from "react-icons/ri";
import DriverIC from "./tabs/ic";
import DriverBank from "./tabs/bank";
import DriverDrivingLicense from "./tabs/drivingLicense";
import DriverPSV from "./tabs/psv";
import DriverVehicle from "./tabs/vehicle";
import DriverTier from "./tabs/tier";
import DriverServiceArea from "./tabs/serviceArea";

const DriverDetail = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState(null)

    const getData = useCallback(async () => {
        const response = await getDriverDetail(id)
        setData(response)
    }, [id])

    useEffect(() => {
        getData()
    }, [getData])

    const tabList = useMemo(() => data ? [
        { key: "order", label: t("ORDER"), content: <DriverOrder userId={data?.driver} /> },
        { key: "wallet", label: t("WALLET"), content: <DriverWallet userId={data?.driver} /> },
        { key: "IC", label: t("IC"), content: <DriverIC /> },
        { key: "BANK", label: t("BANK"), content: <DriverBank /> },
        { key: "DRIVING_LICENSE", label: t("DRIVING_LICENSE"), content: <DriverDrivingLicense /> },
        { key: "PSV", label: t("PSV"), content: <DriverPSV /> },
        { key: "VEHICLE", label: t("VEHICLE"), content: <DriverVehicle /> },
        {
            key: "serviceArea",
            label: t("SERVICE_AREA"),
            content: <DriverServiceArea
                driverId={id}
                currentServiceArea={data?.serviceArea}
                onUpdated={getData}
            />
        },
        {
            key: "tier",
            label: t("TIER"),
            content: <DriverTier
                driverId={id}
                currentTier={data?.tier}
                onTierChanged={getData}
            />
        },
    ] : [], [data, t, id, getData]);

    const details = [
        { label: t("PHONE_NUMBER"), value: `${data?.countryCode}${data?.phoneNumber}` },
        { label: t("EMAIL"), value: data?.email },
        { label: t("GENDER"), value: data?.gender },
        { label: t("REFERENCE_NUMBER"), value: data?.referenceNumber },
        { label: t("DRIVER_TYPE"), value: data?.driverType },
        { label: t("SERVICE_AREA"), value: data?.serviceArea || "-" },
        {
            label: t("RATING"),
            value: typeof data?.rating === "number" ? data.rating.toFixed(2) : "-",
        },
        {
            label: t("DRIVER_TIER"),
            value: data?.tier?.tierName
                ? `${data.tier.tierName}`
                : t("NO_TIER_ASSIGNED")
        },
        {
            label: t("SUSPENDED"),
            value: <span className={data?.suspended ? "text-danger" : "text-success"}>{data?.suspended ? "Yes" : "No"}</span>
        },
        { label: t("JOINED_AT"), value: dayjs(data?.createdAt).format(DATETIME_FORMAT) },
    ];

    return <div className="p-4">
        <DetailHeaderCard
            title={data?.fullName}
            rightComponent={<Button
                size="sm"
                variant="outline-primary"
                icon={<RiEdit2Fill />}
                onClick={() => navigate(Pages.DriverForm.replace(":id", id))}
            />}
            details={details}
        />
        <Tabs tabList={tabList} />
    </div>
}

export default DriverDetail;
